/* [AI] 2026-05-19: 商品画像の右クリック保存・ドラッグ保存を抑止
   完全な保護ではなくカジュアル保存の防止。
   対象: PDP / 商品カード / カートドロワー / Wishlist など、
   .mgh-main-product, .mgh-product-card, .mgh-cart-drawer, mgh-wishlist-list
   配下の <img> に効く */

(function () {
  const PROTECTED_SELECTORS = [
    '.mgh-main-product',
    '.mgh-product-card',
    '.mgh-cart-drawer',
    'mgh-wishlist-list',
    '.mgh-wishlist-page',
  ].join(',');

  function isProtectedImage(target) {
    if (!target || target.tagName !== 'IMG') return false;
    return target.closest(PROTECTED_SELECTORS) !== null;
  }

  document.addEventListener('contextmenu', (event) => {
    if (isProtectedImage(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', (event) => {
    if (isProtectedImage(event.target)) {
      event.preventDefault();
    }
  });
})();
